<template>
  <div class="try">
    <h2 class="title-bunner-container">
      <img class="title-bunner" src="../assets/bunner/trial.png" alt="かつうら体験">
    </h2>
    <div class="container">
      <photo-link-and-text
        title="ツアー情報"
        imgSrc="/static/photos/tour_info.jpg"
        imgAlt="ツアー情報"
        link="http://www.east-tokushima.jp/"
      >
        かつうら町をもっと深く、
        <br>知りたい、楽しみたい、触れあいたい。
        <br>そんなあなたに最適な、
        <br>かつうら町との「出会い方」
        <br>探してみてください。
      </photo-link-and-text>
      <div class="row my-5">
        <router-link class="col-12 btn btn-dark bg-black rounded-0 text-white" to="/year">
          <img src="../assets/arrow_right.png" alt="矢印" class="right-arrow">イベント情報
        </router-link>
      </div>
      <photo-link-and-text
        title="農村体験"
        isRightPhoto
        imgSrc="/static/photos/sakamoto_trial.jpg"
        imgAlt="坂本体験"
        link="https://fureainosato.net/"
      >
        農山村たるかつうら町でできる、
        <br>多彩な農村体験。
        <br>
        <br>町の最奥の集落・坂本地区にある
        <br>「ふれあいの里さかもと」で
        <br>楽しむことができますよ。
      </photo-link-and-text>
      <photo-link-and-text
        title="歩く・走る"
        imgSrc="/static/photos/run_walk.jpg"
        imgAlt="歩く・走る"
        link="https://kfriendskss.wixsite.com/mysite"
      >
        豊かな自然や地形を活かした
        <br>様々なウォーキングイベントや
        <br>マラソンイベントが
        <br>かつうら町でも開催されています。
        <br>
        <br>スポーツクラブ「K-Friends」
        <br>が紹介しています。
      </photo-link-and-text>
      <photo-link-and-text
        title="みかん狩り"
        imgSrc="/static/photos/mikan_farm.jpg"
        imgAlt="みかん狩り"
        link="mikan_gari"
        isRightPhoto
      >
        かつうら町が誇る温州みかんが、
        <br>思う存分楽しめるみかん狩り。
        <br>
        <br>元祖徳島みかんたる町の
        <br>旬の味と香りを、
        <br>ぜひともおためしください。
      </photo-link-and-text>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import PhotoLinkAndText from "@/components/PhotoLinkAndText.vue";

export default {
  name: "stay",
  data: function() {
    return {};
  },
  components: {
    PhotoLinkAndText
  }
};
</script>

<style scoped>
.right-arrow {
  margin-right: 1rem;
  height: 2rem;
  margin-bottom: 3px;
}
</style>